export { default } from './TrailStandardCard';
export type { TrailStandardCardProps } from './TrailStandardCard';
